import { render, staticRenderFns } from "./IndicadoresResumoArmazem.vue?vue&type=template&id=61726853&scoped=true&"
import script from "./IndicadoresResumoArmazem.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoArmazem.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoArmazem.vue?vue&type=style&index=0&id=61726853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61726853",
  null
  
)

export default component.exports